import React, { useState, useEffect } from "react";
import h from "../../../helpers";
import ScheduleBreadCrumbs from "../misc/ScheduleBreadCrumbs";
import ScheduleLogEntry from "./ScheduleLogEntry";
import BouncingDots from "../../loading/BouncingDots";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import { IScheduleLog } from "../../../types/stores/schedules";

type Props = {
    id: string;
    isModal?: boolean;
    name?: string; // modal only
};

const ScheduleLog: React.FC<Props> = ({ id, isModal = false, name }: Props) => {
    const [scheduleLog, setScheduleLog] = useState<Array<IScheduleLog>>([]);
    const [windowsToIanaTimezoneMap, setWindowsToIanaTimezoneMap] = useState<{ [key: string]: string }>({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        const url = "/schedule/schedulelogfor?" + h.serialize({ id });
        fetch(url, { method: "POST", credentials: "same-origin" })
            .then(h.checkStatus)
            .then(h.toJson)
            .then(data => {
                const response = data as unknown as {
                    scheduleLog: Array<IScheduleLog>;
                    windowsToIanaTimezoneMap: { [key: string]: string };
                };
                setScheduleLog(response.scheduleLog);
                setWindowsToIanaTimezoneMap(response.windowsToIanaTimezoneMap);
                setIsLoading(false);
            });
    }, [id]);

    return (
        <div>
            {isModal ? (
                <span style={{ fontSize: "22px", marginLeft: "5px" }}>{name}</span>
            ) : (
                <>
                    <ScheduleBreadCrumbs editId={id} mode="log" />
                    <h3 className="m-t-0">Schedule Action Log</h3>
                </>
            )}
            <div>
                {isLoading && (
                    <div style={{ marginTop: "25px", textAlign: "center" }}>
                        <BouncingDots />
                    </div>
                )}
                {scheduleLog != null && scheduleLog.length > 0 && (
                    <TableContainer className="list-group" style={{ marginTop: 10, overflow: "auto", height: "55vh" }}>
                        <Table>
                            {scheduleLog.map(entry => (
                                <ScheduleLogEntry
                                    key={entry.Id}
                                    entry={entry}
                                    windowsToIanaTimezoneMap={windowsToIanaTimezoneMap}
                                />
                            ))}
                        </Table>
                    </TableContainer>
                )}
            </div>
        </div>
    );
};

export default ScheduleLog;
